import moment from "moment";

export const getFormatDate = async (date: any, format: string = 'YYYY-MM-DD') => {
    return moment.utc(date).local().add(0, 'hours').format(format);
}
export const getFormatDateF =  (date: any, format: string = 'YYYY-MM-DD') => {
    return moment.utc(date).local().add(0, 'hours').format(format);
}
